import Cookie from 'js-cookie';

import { goWebSite } from '@/utils/goWebSite';
// targetStep:老师列表=5; 老师详情=6;
// teacherId: 老师详情=6 时传string (可以不传递了)
export const GS2_TEACHER_LIST = '5';
export const GS2_TEACHER_DETAIL = '6';
export const GS2_STU_MOBILE = 'stu_mobile';
export const GS2_STU_PC = 'stu_PC';
export const goGs2Booking = (value: {
  teacherId?: string;
  source: 'stu_mobile' | 'stu_PC';
  targetStep: '5' | '6';
  trigger_name?: string;
  trigger_pvid?: string;
  type?: string;
  rescheduleUrl?: string;
  appEnv?: string;
  freeCode?: string;
  hiddenH5Nav?: string;
}) => {
  /* 如果是gs2.0的重新预约，则直接使用url上传递的rescheduleUrl */
  if (value.rescheduleUrl) {
    window.location.href = decodeURIComponent(value.rescheduleUrl);
    return;
  }
  goWebSite(
    `experienceClassBooking?targetStep=${value.targetStep}&teacherId=${value?.teacherId || ''}&source=${value.source}&trigger_name=${value.trigger_name}&trigger_pvid=${value.trigger_pvid || Cookie.get('trigger_pvid')}&triggerPvid=${value.trigger_pvid || Cookie.get('trigger_pvid')}&type=${value.type}&appEnv=${value.appEnv}&freeCode=${value.freeCode}${value.hiddenH5Nav ? `&hiddenH5Nav=${value.hiddenH5Nav}` : ''}`,
    { selectedLang: 'en' },
  );
};

/**
 * 获取学习报告的url，携带语言信息
 */
export const getStudyReportUrlWithLang = (url: string, lang: string) => {
  if (url.includes('/zh/') || url.includes('/en/')) {
    return url;
  }
  const urlArr = url.split('/trial-study-report');
  const spliceUrl =
    lang === 'zh' ? '/zh/trial-study-report' : '/en/trial-study-report';
  const jumpUrl = urlArr?.[0] + spliceUrl + urlArr?.[1];

  return jumpUrl;
};
